import { useMemo } from "react";
import { useTheme } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core";
import { useAtomicStyles } from "styles";
import { useTypedTranslations } from "hooks";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    section: {
      backgroundColor: "#ececed",
    },
    rootContainer: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
    },
    titleContainer: {
      textAlign: "center",
      marginTop: "6vh",
      paddingBottom: "3vh",
      [theme.breakpoints.down("sm")]: {
        marginTop: "3vh",
        width: "75vw",
      },
    },
    servicesContainer: {
      marginBottom: "8vh",
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      [theme.breakpoints.down("sm")]: {
        marginBottom: "3vh",
        flexDirection: "column",
        width: "75vw",
      },
    },
    card: {
      display: "flex",
      borderRadius: 10,
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      textAlign: "center",
      padding: 0,
    },
    title: {
      color: "black",
      fontSize: "3rem",
      fontWeight: "bold",
      [theme.breakpoints.down("sm")]: {
        fontSize: "2rem",
      },
    },
    heading: {
      paddingTop: "2vh",
      paddingBottom: "2vh",
      color: "#511e65",
      fontWeight: "bold",
    },
    desc: {
      fontWeight: "lighter",
      lineHeight: "2.1",
    },
    pricesContainer: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      [theme.breakpoints.down("sm")]: {
        flexDirection: "column",
      },
    },
    currentPriceContainer: {
      display: "flex",
      flexDirection: "row",
      alignItems: "baseline",
    },
    old: {
      color: "#c8ca79",
      textDecoration: "line-through",
      textDecorationThickness: "2px",
      marginRight: "15px",
    },
    currency: {
      fontWeight: "lighter",
    },
    new: {
      color: "black",
      fontSize: "2.7rem",
      fontWeight: "bold",
      marginRight: "5px",
      padding: 0,
    },
    duration: {
      fontSize: "1.1rem",
      fontWeight: "bold",
    },
  }),
);

const useServicesSection = () => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const classes = useMemo(() => ({}), []);
  const atomicStyles = useAtomicStyles();
  const [t] = useTypedTranslations();

  return {
    styles,
    classes,
    atomicStyles,
    t,
  };
};

export { useServicesSection as default };
